module.exports = "html {\n  overflow-y: scroll;\n}\n\n.style{\n  font-size: 24px; \n  line-height: 1em;\n   color: #002d62;\n}\n\n.padding-g{\n  padding-bottom: 17px;\n}\n\n.padding-gaps {\n  padding-bottom: 5px;\n}\n\n.padding-gap {\n  padding-bottom: 10px;\n}\n\n.heading{\n  font-size: 30px;\n  line-height: 1em;\n  color: #002d62;\n  margin-top: 20px;\n}\n\n.heading-style{\n  font-size: 14px; \n  color: #002d62;\n}\n\n.gap{\n  padding-bottom: 8px;\n}\n\n"


//////////////////
// WEBPACK FOOTER
// ./client/views/request/accommodations/accommodations.component.css
// module id = ./client/views/request/accommodations/accommodations.component.css
// module chunks = main